import { useDispatch } from 'react-redux';
import { ApiError } from 'services/api';
import { useCreateEspAccount } from 'api/ESPAccountsAPI';
import { addNegativeToast, addPositiveToast } from 'modules/toastContainer';
import { useModalsContext, useSendingPlatformsQueryContext } from '../contexts';

export const useCreateAccount = () => {
  const dispatch = useDispatch();
  const { hideModal } = useModalsContext();
  const { refetchEspAccounts } = useSendingPlatformsQueryContext();

  const { mutate: createAccount, isLoading } = useCreateEspAccount({
    onSuccess: () => {
      refetchEspAccounts();
      dispatch(addPositiveToast('Successfully created account.'));
      hideModal();
    },
    onError: (e: unknown) => {
      const errorText = (e as ApiError)?.response?.data;
      dispatch(addNegativeToast(errorText));
      hideModal();
    },
  });

  return { createAccount, isLoading };
};
